import React from 'react';
import Pages from '../../../../../config/Pages';
import styles from './Title.module.scss';

function Title() {
    return (
        <div className={styles.title}>
            <div>
                <i className="pi pi-arrow-right-arrow-left" />
            </div>
            <div>
                <h4>{Pages.sei.statusProposta.title}</h4>
            </div>
        </div>
    );
}

export default Title;
